<template>
  <form-form @submit="handleSubmitNote" :submitError="addNoteSubmitError">
    <form-datepicker
      placeholder="Date"
      v-model="date"
      v-if="datePicker"
      :right="true"
      :pick-time="true"
      @input="dateChanged" />
    <add-note-field
      v-model.trim="newNote"
      :placeholder="placeholder"
      :startLines="startLines"
      :expandToLines="expandToLines"
      ref="noteField" />
    <div class="grid-x" v-if="!hideButton || !!newNote">
      <div class="cell auto" v-if="buttonRight">
        <form-checkbox-element label="Pin Note" v-model="pinned" />
      </div>
      <div class="cell shrink">
        <form-button type="submit" @click="handleSubmitNote()" :loading="isLoading">Add Note</form-button>
      </div>
      <div class="cell auto text-right" v-if="!buttonRight">
        <form-checkbox label="Pin Note" v-model="pinned" />
      </div>
    </div>
  </form-form>
</template>

<script>
import ContactsService from '../../services/ContactsService'
import { formsMixin } from '../../mixins/forms/formsMixin'
import AddNoteField from './AddNoteField'
import moment from 'moment'

export default {
  components: {
    AddNoteField
  },
  mixins: [
    formsMixin
  ],
  props: {
    contactId: Number,
    placeholder: String,
    expandToLines: Number,
    startLines: Number,
    buttonRight: Boolean,
    datePicker: Boolean,
    hideButton: Boolean
  },
  data () {
    return {
      addNoteSubmitError: null,
      newNote: '',
      date: moment().format('YYYY-MM-DD HH:mm'),
      pinned: false,
      isLoading: false
    }
  },
  methods: {
    async handleSubmitNote () {
      if (!this.newNote) {
        return
      }
      if (this.isLoading) {
        return
      }
      this.isLoading = true
      try {
        const date = this.datePicker ? this.date : null
        await ContactsService.addContactNote(this.contactId, this.newNote, date, this.pinned)
        // emit an event after the note is added
        this.$emit('added', this.newNote)
      } catch (e) {
        this.addNoteSubmitError = e
      }
      // clear note and end processing
      this.newNote = ''
      this.isLoading = false
    },
    dateChanged () {
      // if the date is cleared, default to today's date
      if (!this.date) {
        this.date = moment().format('YYYY-MM-DD HH:mm')
      }
    }
  }
}
</script>
